import {Component, Input, OnInit} from '@angular/core';
import {ScreenService} from '@app/core';
import {Observable} from 'rxjs';
import { Router} from '@angular/router';

@Component({
  selector: 'app-st-icon',
  standalone: false,

  templateUrl: './custom-icon.component.html',
  styleUrl: './custom-icon.component.less'
})
export class CustomIconComponent implements OnInit {

  @Input() name: string = '';
  @Input() filled: boolean = false;
  @Input() bold: boolean = false;
  @Input() avatar: boolean = false;
  @Input() bigAvatar: boolean = false;
  @Input() smallAvatar: boolean = false;
  @Input() avatarDecoration: string | undefined;

  @Input() color: string | undefined;

  isFontReady$: Observable<boolean>;
  notPlaceHolder: boolean = false;

  constructor(private screenService: ScreenService,
              private router: Router,) {
    this.isFontReady$ = this.screenService.fontsLoaded$;

    const currentUrl = this.router.url
    this.notPlaceHolder = currentUrl.includes('estado-pago') || currentUrl.includes('orden-compra');
  }

  async ngOnInit() {
  }

}
